import { productIdFormat, taskIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const removeCycleCountProducts = {
  name: "removeCycleCountProducts" as const,
  input: z.object({
    taskId: taskIdFormat.schema,
    productIds: z.array(productIdFormat.schema).min(1).max(500),
  }),
  output: z.object({ removedCount: z.number() }),
};
